import { FormBase } from "core/components";

export default class ContactDepartmentEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "name",
                    label: "CONTACT_DEPARTMENT.EDIT.NAME_LABEL",
                    placeholder: "CONTACT_DEPARTMENT.EDIT.NAME_PLACEHOLDER",
                    rules: ["string", "max:50", "required"],
                },
                {
                    name: "contactDepartmentTypeId",
                    label: "CONTACT_DEPARTMENT.EDIT.TYPE_LABEL",
                    rules: ["string", "required"],
                },
                { name: "overviewRecipientType", type: "text" },
                { name: "docRequestRecipientType", type: "text" },
                { name: "inventoryRecipientType", type: "text" },
                { name: "pickTicketRecipientType", type: "text" },
                { name: "deliveryTicketType", type: "text" },
            ],
        };
    }
}
